(() => {
  let origTitle = document.title;
  const delay = Math.max((theme.settings.blurMessageDelay || 4) * 1000, 2000);
  let timer;
  let cycleTimer;

  const getCartCount = () => {
    // 1. Look for live cart badge in header
    const badge = document.querySelector('#cart-icon-bubble .header__cart-count-number') || document.querySelector('.header__cart-count');
    if (badge) {
      const parsed = parseInt(badge.textContent.trim(), 10);
      if (!isNaN(parsed) && parsed > 0) return parsed;
    }
    // 2. Check theme settings initial cart count
    if (typeof theme.settings.cartItemCount === 'number' && theme.settings.cartItemCount > 0) {
      return theme.settings.cartItemCount;
    }
    return 0;
  };

  const getMessages = (count) => {
    if (!count || count <= 0) return null;
    const countStr = '(' + count + ')';
    const msg1Tpl = theme.settings.blurMessage1 || '[count] in je winkelmandje | Tormino';
    const msg2Tpl = theme.settings.blurMessage2 || 'Verwachte verzenddag per artikel vermeld';

    const msg1 = msg1Tpl.replace(/\[count\]/g, countStr);
    const msg2 = countStr + ' ' + msg2Tpl;
    return [msg1, msg2];
  };

  const startBlur = () => {
    if (!document.title.startsWith('(')) {
      origTitle = document.title;
    }

    const count = getCartCount();
    // CRO: Only change tab title if cart has items!
    // If cart is empty, keep original product/collection page title so comparison shoppers know what tab this is.
    if (!count || count <= 0) {
      return;
    }

    const messages = getMessages(count);
    if (!messages || messages.length === 0) return;

    let step = 0;
    const rotate = () => {
      document.title = messages[step % messages.length];
      step++;
      cycleTimer = setTimeout(rotate, 3500);
    };
    rotate();
  };

  const stopBlur = () => {
    clearTimeout(timer);
    clearTimeout(cycleTimer);
    if (origTitle) {
      document.title = origTitle;
    }
  };

  window.addEventListener('blur', () => {
    timer = setTimeout(startBlur, delay);
  });

  window.addEventListener('focus', stopBlur);

  window.addEventListener('DOMContentLoaded', () => {
    origTitle = document.title;
  });
})();
